import type { AxiosError } from 'axios';
import { manageAPIError } from '../../../../utils';

type ParsedLoginError =
  | { type: 'passwordExpired' }
  | { type: 'mfaRequired'; mfaType?: string }
  | { type: 'validationRequired'; message: string }
  | { type: 'generic'; message: string };

export function parseLoginError(error: AxiosError<any>): ParsedLoginError {
  const status = error.response?.status;
  const data = error.response?.data;

  switch (status) {
    case 418:
      return { type: 'passwordExpired' };

    case 307:
      return { type: 'mfaRequired', mfaType: data?.mfaType };

    case 412:
      return {
        type: 'validationRequired',
        message: manageAPIError(error, 'Email validation required.'),
      };

    case 401:
      return {
        type: 'generic',
        message: 'Login failed. Please double check your email and password.',
      };

    case 409:
      return {
        type: 'generic',
        message: manageAPIError(
          error,
          'Invalid credentials. Please try again.'
        ),
      };

    default:
      return {
        type: 'generic',
        message: 'An unexpected error occurred. Please try again.',
      };
  }
}
